import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import appUrls from '../config/urls';
import { authenticationEnum } from '../components/shared/layout/menu-sidebar/menu-sidebar.component';
import { LoginResponse } from '../data/models/login-response';
import { AuthService } from './auth.service';
import { CustomerLogoutDTO } from '../data/models/logout-request';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  constructor(private http: HttpClient, private router: Router, private authService: AuthService) { }

  getUser(user) {
    let url = appUrls.Authentication.user;
    return this.http.post(url, user);
  }



  login(user: LoginResponse) {
    var claims = this.authService.getTokenClaims(user.token);

    sessionStorage.setItem('userId', claims.UserId);
    sessionStorage.setItem('accountId', claims.AccountId);
    sessionStorage.setItem(authenticationEnum.loggedIn, authenticationEnum.true);
    sessionStorage.setItem(authenticationEnum.username, user.userName);
    sessionStorage.setItem(authenticationEnum.token, user.token);
    sessionStorage.setItem(authenticationEnum.refreshToken, user.refreshToken);
    if (user.logoImage) {
      //console.log("user.logoImage", user.logoImage);
      sessionStorage.setItem(authenticationEnum.logoImage, user.logoImage);
    }

    this.router.navigate(['splash']);

  }

  logout() {
    var token = sessionStorage.getItem(authenticationEnum.token);
    var claims = this.authService.getTokenClaims(token)
    if (claims) {
      this.logoutUser(claims).subscribe();
    }

    sessionStorage.removeItem(authenticationEnum.token);
    sessionStorage.removeItem(authenticationEnum.refreshToken);
    sessionStorage.removeItem(authenticationEnum.loggedIn);
    sessionStorage.removeItem(authenticationEnum.username);

    this.router.navigate(['/login']);
  }

  logoutUser(claims:any) {

      let userId = claims.UserId
      if (userId) {
        let parsedUserId = parseInt(userId);
        let url = appUrls.Authentication.logout;
        let logoutModel: CustomerLogoutDTO = { userId: parsedUserId };
        return this.http.post(url, logoutModel);
    }
  }

  

  createLoginTime() {
    sessionStorage.setItem(authenticationEnum.loginTime, (new Date()).toString());
  }

  createUserAuthorization() {
    sessionStorage.setItem(authenticationEnum.hasAccess, authenticationEnum.true);
  }

  isUserAuthenticated(): boolean {
    return sessionStorage.getItem(authenticationEnum.loggedIn) != null || sessionStorage.getItem(authenticationEnum.loggedIn) == authenticationEnum.true ||
      sessionStorage.getItem(authenticationEnum.token) != null || !this.authService.isTokenExpired();
  }

  isUserAuthorized(): boolean {
    let hasNul = sessionStorage.getItem(authenticationEnum.hasAccess) != null;
    let hasTrue = sessionStorage.getItem(authenticationEnum.hasAccess) == authenticationEnum.true;
    return hasNul && hasTrue;
  }

  isHasAccessTo(page): boolean {
    let accessString: string = sessionStorage.getItem(authenticationEnum.access);
    if (accessString == 'All') return true;
    var accesses = accessString.split('-');

    if (accesses.indexOf(page) > -1)
      return true;

    return false;
  }
}

export var GlobleVariables = {
  userId: ''[''],
  accountId: ''['']
}
